import {createAction, props} from "@ngrx/store";
import {ActionsTypes} from "@/auth/store/action.type";

export const SetRoleAction = createAction(
  ActionsTypes.SET_ROLE,
  props<{role: number, user: string}>()
)
